module.exports = __webpack_public_path__ + "assets/otherIcon.61de1d58.svg";